module.exports = __webpack_public_path__ + "static/img/autoship_logo.e91866e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/autoship_logo.png
// module id = 55
// module chunks = 1